import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { LoggingService } from '../../services/shared/logging/logging.service';

@Directive({
  selector: '[appSelectOnFocus]',
  standalone: true,
})
export class SelectOnFocusDirective {
  private loggingService = inject(LoggingService);
  
  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('focus')
  onFocus(): void {
    const element = this.el?.nativeElement;

    // Safety checks to ensure element is valid and selectable
    if (!element ||
      typeof element.select !== 'function' ||
      element.disabled ||
      element.readOnly) {
      return;
    }

    // Use requestAnimationFrame to ensure selection happens after focus is fully established
    requestAnimationFrame(() => {
      try {
        element.select();
      } catch (error) {
        // Silently handle any selection errors (e.g., if element becomes unavailable)
        this.loggingService.debug('SelectOnFocusDirective: Could not select text', 'SelectOnFocusDirective');
      }
    });
  }
}
